export default {
  not_started:
    'Richten Sie Ihr Auszahlungskonto ein — Ihre Umsatzbeteiligung wird bis zur Verifizierung zurückgehalten.',
  bank_account_missing:
    'Hinterlegen Sie ein Bankkonto für Auszahlungen — bis dahin wird Ihre Umsatzbeteiligung zurückgehalten.',
  incomplete:
    'Ihr Auszahlungskonto ist noch nicht vollständig verifiziert — bis dahin wird Ihre Umsatzbeteiligung zurückgehalten.',
  add_bank_account: 'Bankkonto hinzufügen',
  cta: 'Einrichtung abschließen',
};
